import { BannerResponse } from "api"
import NextImage from "components/Reusable/Bit/NextImage"
import { motion } from "framer-motion"
import { useState } from "react"
import styled from "styled-components"
import MainBannerSlider from "./MainBannerSlider"

const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
  background-color: ${(p) => p.theme.colors.white};
  position: relative;

  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 20px;
    padding: 0px;
    height: 600px;
  }
`
const StyledBackgroundImageWrapper = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* z-index: 0; */
`

type MainBannerProps = {
  divRef: React.RefObject<HTMLDivElement>
  banners: BannerResponse[]
}

const MainBanner = ({ divRef, banners }: MainBannerProps) => {
  const [imgUrl, setImgUrl] = useState("")

  return (
    <StyledWrapper tabIndex={-1}>
      <StyledBackgroundImageWrapper
        key={imgUrl}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1.5 }}
      >
        {imgUrl && (
          <NextImage
            image={{ imageUrl: imgUrl, alt: "" }}
            sizes="100vw"
            cover
          />
        )}
      </StyledBackgroundImageWrapper>
      <MainBannerSlider
        bannerData={banners}
        divRef={divRef}
        setImgUrl={setImgUrl}
      />
    </StyledWrapper>
  )
}

export default MainBanner
